import { useMutation } from '@tanstack/react-query';
import UserService, { IUserSorter } from '@services/userService';

interface UseStudentsComprehensiveDownloadParams {
  page: number;
  sort: IUserSorter;
  searchTerm?: string;
  subscriptionStatusUser?: any;
}

export const useStudentsComprehensiveDownload = () => {
  return useMutation({
    mutationFn: (params: UseStudentsComprehensiveDownloadParams) =>
      UserService.getAllStudentsComprehensiveDownload(params),
    retry: 1,
    onError: (error) => {
      console.error('Error fetching comprehensive student data:', error);
    },
  });
};
